module.exports = __webpack_public_path__ + "static/media/tunghørt.0f20cc33.m4a";